import DeleteIcon from "@mui/icons-material/Delete";
import { Autocomplete, MenuItem, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import { visuallyHidden } from "@mui/utils";
import { format } from "date-fns";
import PropTypes from "prop-types";
import * as React from "react";
import { useEffect, useState } from "react";
import { retrieveAllItemsApi } from "../../../components/api/ItemApiService";
import { retrieveAllStakeholdersApi } from "../../../components/api/StakeholderApiService";
import {
  retrieveAllTradeRecordsApi,
  retrieveFilteredRecordsApi,
} from "../../../components/api/TradeApiService";
import { retrieveAllWarehouseApi } from "../../../components/api/WarehouseApiService";
import ExportExcel from "../../../utils/excelExport";
import {
  companies,
  operationType,
  recordStatus,
  shippingInstructionStatus,
  units,
} from "../../../utils/menu-items";
import AddTrade from "./AddTrade";
import EditTrade from "./EditTrade";
import EditItem from "../ItemView/EditItem";
import ItemButton from "./Dialogs/ItemButton";
import EditVendorOrder from "../VendorOrderView/EditVendorOrder";
import OrderButton from "./Dialogs/OrderButton";
import EditCustomerOrder from "../CustomerOrder/EditCustomerOrder";
import ShipmentRequestButton from "./Dialogs/ShipmentRequestView";
import EditShipmentRequest from "../ShipmentRequestView/EditShipmentRequest";
import EditShippingInstruction from "../ShippingInstructionView/EditShippingInstruction";
import ShippingInstructionButton from "./Dialogs/ShippingInstructionButton";
import {retrieveFastShipmentRequestsApi } from "../../../components/api/ShipmentRequestApiService";
import {retrieveFastShippingInstructionsApi } from "../../../components/api/ShippingInstructionApiService";
import { retrieveFastOrdersApi } from "../../../components/api/OrderApiService";
import { isEmpty } from "lodash";
import { exportTradeRelations } from "./BuildTradeGraph";
import TradeRelationsGraphDialog from "./BuildTradeGraphExcel";
import MyFilters from "../../../components/MyFilters";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: false,
    label: "Trade ID",
  },
  {
    id: "po",
    numeric: false,
    disablePadding: false,
    label: "PO",
  },
  {
    id: "so",
    numeric: true,
    disablePadding: false,
    label: "SO",
  },
  {
    id: "shipmentRequest",
    numeric: true,
    disablePadding: false,
    label: "SR",
  },
  {
    id: "shippingInstructionId",
    numeric: true,
    disablePadding: false,
    label: "SI",
  },
  {
    id: "operationType",
    numeric: false,
    disablePadding: true,
    label: "Operation",
  },
  {
    id: "recordStatus",
    numeric: false,
    disablePadding: true,
    label: "Record",
  },
  {
    id: "operationInfo",
    numeric: false,
    disablePadding: true,
    label: "",
  },
  {
    id: "operationDate",
    numeric: false,
    disablePadding: true,
    label: "Issue Date",
  },
  {
    id: "poCompany",
    numeric: true,
    disablePadding: true,
    label: "PO Company",
  },
  {
    id: "soCompany",
    numeric: true,
    disablePadding: true,
    label: "SO Company",
  },
    {
    id: "numberOfCases",
    numeric: true,
    disablePadding: false,
    label: "Number Of Cartons",
  },
  {
    id: "caseNetWeight",
    numeric: true,
    disablePadding: false,
    label: "Net Weight Per Carton",
  },
  {
    id: "volume",
    numeric: true,
    disablePadding: false,
    label: "Volume",
  },
  {
    id: "itemId",
    numeric: true,
    disablePadding: true,
    label: "Item ID",
  },
  {
    id: "itemBuyingGrade",
    numeric: false,
    disablePadding: true,
    label: "Buying Grade",
  },
  {
    id: "itemSgiGrade",
    numeric: false,
    disablePadding: true,
    label: "Sales Grade",
  },
    {
    id: "customerGradeMark",
    numeric: false,
    disablePadding: true,
    label: "Customer Grade Mark",
  },
  {
    id: "crop",
    numeric: true,
    disablePadding: true,
    label: "Crop",
  },
  {
    id: "itemOrigin",
    numeric: false,
    disablePadding: true,
    label: "Origin",
  },
  {
    id: "warehouse",
    numeric: false,
    disablePadding: true,
    label: "Warehouse",
  },
  {
    id: "destination",
    numeric: false,
    disablePadding: true,
    label: "Destination",
  },
  {
    id: "poBusinessPartner",
    numeric: false,
    disablePadding: true,
    label: "PO Business Partner",
  },
  {
    id: "soBusinessPartner",
    numeric: false,
    disablePadding: true,
    label: "SO Business Partner",
  },
  {
    id: "portOfLoading",
    numeric: false,
    disablePadding: true,
    label: "Port Of Loading",
  },
  {
    id: "portOfDischarge",
    numeric: false,
    disablePadding: true,
    label: "Port Of Discharge",
  },
  {
    id: "actualTimeOfArrival",
    numeric: true,
    disablePadding: false,
    label: "ATA",
  },
  {
    id: "creationTime",
    numeric: false,
    disablePadding: true,
    label: "Creation Time",
  },
  {
    id: "createdBy",
    numeric: false,
    disablePadding: true,
    label: "Created By",
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all desserts",
            }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={
              headCell.id === "id"
                ? {
                    position: "sticky",
                    left: 0,
                    zIndex: 3,
                  }
                : headCell.id === "operationType"
                ? {
                    position: "sticky",
                    left: 50,
                    zIndex: 3,
                  }
                : headCell.id === "operationInfo"
                ? {
                    position: "sticky",
                    left: 150,
                    zIndex: 3,
                  }
                : null
            }
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected, showFilters, setShowFilters, selected, selectedData } =
    props;
const [graphOpen, setGraphOpen] = React.useState(false);
  function formatDate(isoDateString) {
    const date = new Date(isoDateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }
  
  function createNewExportObject(rows) {
    const newObjects = [];
    const headerMapping = {
      "Trade ID": "id",
      "PO ID": (row) =>
        row?.shippingInstructionShipmentRequestPurchaseOrderId ||
      row?.shipmentRequestPurchaseOrderId ||
      ((row?.operationType === "PO" ||
        row?.operationType === "PO CANCELLATION") &&
        row?.orderId) || "",
      "SO ID": (row) =>
        row?.shippingInstructionShipmentRequestSalesOrderId ||
                                row?.shipmentRequestSalesOrderId ||
                                ((row?.operationType === "SO" ||
                                  row?.operationType === "SO CANCELLATION") &&
                                  row?.orderId),
      "SR ID": (row) =>
        row?.shippingInstructionShipmentRequestId ||
                                row?.shipmentRequestId,
      "SI ID": (row) =>
        row?.shippingInstructionId,
      "Operation": "operationType",
      "Record Status": (row) =>
        (row?.shippingInstructionRecordStatus && row.shippingInstructionRecordStatus.split('')[0]) ||
                              (row?.shipmentRequestRecordStatus && row.shipmentRequestRecordStatus.split('')[0]) ||
                              (row?.orderRecordStatus && row.orderRecordStatus.split('')[0]),
      "": (row) =>
        (row?.shippingInstructionId &&
          `${
            row?.shippingInstructionShipmentRequestType
          } ${
            row?.finalShippingInstructionNumber || ""
          }`) ||
          (row?.operationType === "PO" &&
            row?.purchaseOrderNumber) ||
          (row?.operationType === "SO" &&
            row?.salesOrderNumber) ||
          (row?.operationType === "SR" &&
            row?.shipmentRequestType) ||
          "",
      "Issue Date": (row) =>(
        (row?.shippingInstructionDate
          ? format(
              new Date(
                row?.shippingInstructionDate,
              ),
              "dd/MM/yyyy",
            )
          : "") ||
          (row?.shipmentRequestDate
            ? format(
                new Date(row?.shipmentRequestDate),
                "dd/MM/yyyy",
              )
            : "") ||
          (row?.orderDate
            ? format(
                new Date(row?.orderDate),
                "dd/MM/yyyy",
              )
            : "")),
      "PO Company": (row) =>
        row?.shippingInstructionShipmentRequestPurchaseOrderCompany ||
      row?.shipmentRequestPurchaseOrderCompany ||
      ((row?.operationType === "PO" ||
        row?.operationType === "PO CANCELLATION") &&
        row?.orderCompany) ,
      "SO Company": (row) =>
        row?.shippingInstructionShipmentRequestSalesOrderCompany ||
                              row?.shipmentRequestSalesOrderCompany ||
                              ((row?.operationType === "SO" ||
                                row?.operationType === "SO CANCELLATION") &&
                                row?.orderCompany),
      "Item ID": (row) =>
        row?.shippingInstructionShipmentRequestPurchaseOrderOfferItemId ||
                                row?.shippingInstructionShipmentRequestSalesOrderOfferItemId ||
                                row?.shipmentRequestPurchaseOrderOfferItemId ||
                                row?.shipmentRequestSalesOrderOfferItemId ||
                                row?.orderOfferItemId,
      "Buying Grade":  (row) =>
        row?.shippingInstructionShipmentRequestPurchaseOrderOfferItemBuyingGrade ||
                              row?.shippingInstructionShipmentRequestSalesOrderOfferItemBuyingGrade ||
                              row?.shipmentRequestPurchaseOrderOfferItemBuyingGrade ||
                              row?.shipmentRequestSalesOrderOfferItemBuyingGrade ||
                              row?.orderOfferItemBuyingGrade ||
                              row?.orderOfferItemBuyingGrade,
      "Sales Grade": (row) =>
      row?.shippingInstructionShipmentRequestSalesOrderOfferSalesGrade ||
      row?.shipmentRequestSalesOrderOfferSalesGrade ||
      row?.orderOfferSalesGrade ||
      row?.orderOfferSalesGrade ,
      Crop: (row) =>
        row?.shippingInstructionShipmentRequestPurchaseOrderOfferItemCrop ||
                              row?.shippingInstructionShipmentRequestSalesOrderOfferItemCrop ||
                              row?.shipmentRequestPurchaseOrderOfferItemCrop ||
                              row?.shipmentRequestSalesOrderOfferItemCrop ||
                              row?.orderOfferItemCrop ||
                              row?.orderOfferItemCrop,
       "Customer Grade Mark": (row) =>
      row?.shippingInstructionShipmentRequestCustomerGradeMark||
      row?.shipmentRequestCustomerGradeMark,           
      Origin: (row) =>
        row?.shippingInstructionShipmentRequestPurchaseOrderOfferItemOrigin ||
          row?.shippingInstructionShipmentRequestSalesOrderOfferItemOrigin ||
          row?.shipmentRequestPurchaseOrderOfferItemOrigin ||
          row?.shipmentRequestSalesOrderOfferItemOrigin ||
          row?.orderOfferItemOrigin ||
          row?.orderOfferItemOrigin ,
      "Warehouse": (row) =>
        row?.shippingInstructionWarehouse ||
                              row?.shipmentRequestWarehouse,
      "Destination": (row) =>
        row?.shippingInstructionDestination ||
                              row?.shipmentRequestDestination,
      "PO BP": (row) =>
        row?.shippingInstructionShipmentRequestPurchaseOrderOfferStakeholderName ||
                              row?.shipmentRequestPurchaseOrderOfferStakeholderName ||
                              (row?.operationType === "PO" &&
                                row?.orderOfferStakeholderName),
      "SO BP": (row) =>
        row?.shippingInstructionShipmentRequestSalesOrderOfferStakeholderName ||
                              row?.shipmentRequestSalesOrderOfferStakeholderName ||
                              (row?.operationType === "SO" &&
                                row?.orderOfferStakeholderName),
      "POL": (row) =>
        row?.shippingInstructionPointOfLoading ||
                              row?.shipmentRequestPortOfLoading ||
                              row?.orderPortOfLoading,
      "POD": (row) =>
        row?.shippingInstructionPointOfUnloading ||
                              row?.shipmentRequestPortOfDischarge ||
                              row?.orderPortOfDischarge,
      "Number Of Cartons": (row) =>
        row?.shippingInstructionShipmentRequestNumberOfCases ||
                              row?.shipmentRequestNumberOfCases ||
                              row?.orderNumberOfCases,
      "Net Weight Per Carton": (row) =>
        row?.shippingInstructionShipmentRequestNetWeightPerCase ||
                              row?.shipmentRequestNetWeightPerCase ||
                              row?.orderNetWeightPerCase,
      "Volume": (row) =>
        row?.shippingInstructionShipmentRequestShipmentQuantity
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(
                                  row?.shippingInstructionShipmentRequestShipmentQuantity,
                                )} ${
                                  row?.shippingInstructionShipmentRequestShipmentQuantityUnit
                                }`
                              : "" || row?.shipmentRequestShipmentQuantity
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(
                                  row?.shipmentRequestShipmentQuantity,
                                )} ${
                                  row?.shipmentRequestShipmentQuantityUnit
                                }`
                              : "" || row?.orderVolume
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row?.orderVolume)} ${
                                  row?.orderVolumeUnit
                                }`
                              : "",
      "ATA": (row) =>
        row?.shippingInstructionActualTimeOfArrival
      ? format(
          new Date(
            row?.shippingInstructionActualTimeOfArrival,
          ),
          "dd-MMM-yyyy",
        )
      : "",
    };

    rows.forEach((row) => {
      const newObject = {};
      Object.entries(headerMapping).forEach(([header, pathOrFunction]) => {
        let value;
        if (typeof pathOrFunction === "function") {
          value = pathOrFunction(row); 
        } else {
          const keys = pathOrFunction.split("?.");
          value = row;
          for (const key of keys) {
            if (value == null) break;
            value = value[key];
          }
        }
        if (header.endsWith("Date") && value) {
          value = formatDate(value);
        }
        newObject[header] = value ?? ""; 
      });
      newObjects.push(newObject);
    });

    return newObjects;
  }
  
  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity,
            ),
        }),
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Stack direction="row" spacing={1} alignItems={"center"}>
        <Typography
          sx={{ fontWeight: 600, fontSize: "20px" }}
          variant="h6"
          id="tableTitle"
          component="div"
          color="#1E2685"
        >
          Trade History
        </Typography>

        <Typography></Typography>
        {numSelected > 0 ? (
          <Typography
            sx={{ fontWeight: 200, fontSize: "16px" }}
            color="#1E2685"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (
          <Typography></Typography>
        )}

        {numSelected > 0 && (
          <Tooltip title="Delete">
            <IconButton>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
      <Stack direction={"row"} spacing={1} sx={{ mr: 2 }}>
        <TradeRelationsGraphDialog
        open={graphOpen}
        onClose={() => setGraphOpen(false)}
        rows={selectedData}
      />
         <Button
          variant="outlined"
          size="small"
          disabled={!selectedData?.length}
          onClick={() => setGraphOpen(true)}
        >
          View Relations Graph
        </Button>
       {/* <Button
          variant="outlined"
          size="small"
          disabled={!selectedData?.length}
          onClick={() => exportTradeRelations(selectedData, "trade-relations", "dot")}
        >
          Export Relations (DOT)
        </Button>*/}
      <ExportExcel
          excelData={createNewExportObject(selectedData)}
          fileName={"TradeHistoryExport"}
          buttonLabel="Export Table"
        />
        <Button
          variant="outlined"
          onClick={() => setShowFilters(!showFilters)}
          sx={{ minWidth: "130px" }}
          size="small"
        >
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
      </Stack>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function TradeView() {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [addView, setAddView] = useState(false);
  const [addViewStates, setAddViewStates] = useState(null);
  const [rows, setRows] = useState([]);
  const [items, setItems] = useState([]);
  const [stakeholders, setStakeholders] = useState([]);
  const [showFilters, setShowFilters] = useState();
  const [warehouses, setWarehouses] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [shipmentRequests, setShipmentRequests] = useState([]);
  const [shippingInstructions, setShippingInstructions] = useState([]);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [salesOrders, setSalesOrders] = useState([]);

    const [editItem, setEditItem] = useState({
      visible: false,
      data: null,
      index: null,
    });
    
      const [editVendorOrder, setEditVendorOrder] = useState({
        visible: false,
        data: null,
        index: null,
      });

      const [editCustomerOrder, setEditCustomerOrder] = useState({
        visible: false,
        data: null,
        index: null,
      });
      
      const [editShipmentRequest, setEditShipmentRequest] = useState({
        visible: false,
        data: null,
        index: null,
      });

      const [editShippingInstruction, setEditShippingInstruction] = useState({
        visible: false,
        data: null,
        index: null,
      });

  function retrieveWarehouse() {
    retrieveAllWarehouseApi()
      .then((response) => {
        setWarehouses(response?.data);
        setDestinations(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

    function retrieveShipmentRequests() {
      retrieveFastShipmentRequestsApi()
        .then((response) => {
          setShipmentRequests(response?.data);
        })
        .catch((error) => console.log(error.response?.data));
    }
  
        function retrieveShippingInstructions() {
      retrieveFastShippingInstructionsApi()
        .then((response) => {
          setShippingInstructions(response?.data);
        })
        .catch((error) => console.log(error.response?.data));
    }

      function retrieveOrders(type) {
        retrieveFastOrdersApi(type)
          .then((response) => {
            if (type === "VENDOR") {
              setPurchaseOrders(response?.data);
            } else if (type === "CUSTOMER") {
              setSalesOrders(response?.data);
            }
          })
          .catch((error) => console.log(error.response?.data));
      }
    

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const [filterTrade, setFilterTrade] = useState({
    id: 0,
    recordStatusList: ["ACTIVE"],
    isEmptyShipmentRequest: [],
    isEmptyShippingInstruction: [],
    isEmptyPurchaseOrder: [],
    isEmptySalesOrder: [],
  });

  useEffect(() => retrieveTrades(), []);

  function retrieveTrades() {
    retrieveAllTradeRecordsApi()
      .then((response) => {
        setRows(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveItems() {
    retrieveAllItemsApi()
      .then((response) => {
        setItems(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveStakeholders() {
    Promise.all([
      retrieveAllStakeholdersApi("VENDOR"),
      retrieveAllStakeholdersApi("CUSTOMER"),
    ])
      .then(([vendorResponse, customerResponse]) => {
        setStakeholders([...vendorResponse?.data, ...customerResponse?.data]);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const [editTrade, setEditTrade] = useState({
    visible: false,
    data: null,
    index: null,
  });

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      setSelectedData(rows);
      return;
    } else {
      setSelected([]);
      setSelectedData([]);
    }
  };

  const handleClick = (event, name, row) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    const selectedDataIndex = selectedData.indexOf(row);
    let newSelectedData = [];

    if (selectedDataIndex === -1) {
      newSelectedData = newSelectedData.concat(selectedData, row);
    } else if (selectedDataIndex === 0) {
      newSelectedData = newSelectedData.concat(selectedData.slice(1));
    } else if (selectedDataIndex === selectedData.length - 1) {
      newSelectedData = newSelectedData.concat(selectedData.slice(0, -1));
    } else if (selectedDataIndex > 0) {
      newSelectedData = newSelectedData.concat(
        selectedData.slice(0, selectedDataIndex),
        selectedData.slice(selectedDataIndex + 1),
      );
    }
    setSelectedData(newSelectedData);

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const [componentsState, setComponentsState] = useState({
    item: {
      dropdownOpen: false,
      inputValue: "",
    },
    poStakeholder: {
      dropdownOpen: false,
      inputValue: "",
    },
    soStakeholder: {
      dropdownOpen: false,
      inputValue: "",
    },
    destination: {
      dropdownOpen: false,
      inputValue: "",
    },
    warehouse: {
      dropdownOpen: false,
      inputValue: "",
    },
        shippingInstruction: {
      dropdownOpen: false,
      inputValue: "",
    },
        shipmentRequest: {
      dropdownOpen: false,
      inputValue: "",
    },
        purchaseOrder: {
      dropdownOpen: false,
      inputValue: "",
    },
        salesOrder: {
      dropdownOpen: false,
      inputValue: "",
    },
  });

  const updateComponentState = (componentKey, newState) => {
    setComponentsState((prevState) => ({
      ...prevState,
      [componentKey]: {
        ...prevState[componentKey],
        ...newState,
      },
    }));
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, rows, editTrade],
  );

  return (
    <div>
      {addView ? (
        <AddTrade
          setAddViewStates={setAddViewStates}
          addViewStates={addViewStates}
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
        />
      ) : editTrade.visible ? (
        <EditTrade
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editTrade={editTrade}
          setEditTrade={setEditTrade}
        />
      ) : editItem.visible ? (
        <EditItem
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editItem={editItem}
          setEditItem={setEditItem}
        />
      ) : editVendorOrder.visible ? (
        <EditVendorOrder
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editVendorOrder={editVendorOrder}
          setEditVendorOrder={setEditVendorOrder}
        />
      ) : editCustomerOrder.visible ? (
        <EditCustomerOrder
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editCustomerOrder={editCustomerOrder}
          setEditCustomerOrder={setEditCustomerOrder}
        />
      ) : editShipmentRequest.visible ? (
        <EditShipmentRequest
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editShipmentRequest={editShipmentRequest}
          setEditShipmentRequest={setEditShipmentRequest}
        />
      ): editShippingInstruction.visible ? (
        <EditShippingInstruction
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editShippingInstruction={editShippingInstruction}
          setEditShippingInstruction={setEditShippingInstruction}
        />
      ):(
        <>
          {showFilters && (
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-start"
                alignItems="center"
              >
                <TextField
                  label="Operation Type"
                  type="search"
                  id="outlined-select-operation-type"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterTrade.operationTypeList || [],
                    onChange: (e) => {
                      setFilterTrade({
                        ...filterTrade,
                        operationTypeList: e.target.value,
                      });
                    },
                  }}
                >
                  {operationType.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  id="date"
                  type="date"
                  label="Operation Date"
                  value={filterTrade?.operationDate || ""}
                  inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                  onChange={(e) =>
                    setFilterTrade({
                      ...filterTrade,
                      operationDate: e.target.value,
                    })
                  }
                />

                <Autocomplete
                  multiple
                  id="outlined-select-shipping-instruction"
                  disableClearable
                  open={componentsState.shippingInstruction.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("shippingInstruction", {
                      dropdownOpen: true,
                    })
                  }
                  inputValue={componentsState.shippingInstruction.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("shippingInstruction", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
options={[
    { id: 'emptyShippingInstructions' }, 
  ...shippingInstructions.filter((shippingInstruction) =>
    filterTrade?.shippingInstructionIdList?.includes(
      shippingInstruction.id,
    ),
  ),
  ...shippingInstructions.filter(
    (shippingInstruction) =>
      !filterTrade?.shippingInstructionIdList?.includes(
        shippingInstruction.id,
      ),
  ),// Add this special option
]}
                  getOptionLabel={(option) => {
                    const values = [
                      option?.id,
                      option?.finalShippingInstructionNumber
                        ? `SI Number: ${option.finalShippingInstructionNumber}`
                        : null,
                      option?.purchaseOrderNumber
                        ? `SAP PO Number: ${option.purchaseOrderNumber}`
                        : null,
                      option?.purchaseOrderItemOrigin
                        ? `Origin: ${option.purchaseOrderItemOrigin}`
                        : option?.salesOrderItemOrigin 
                        ? `Origin: ${option.salesOrderItemOrigin}`
                        : null,
                         option?.purchaseOrderItemCrop
                        ? `Crop: ${option.purchaseOrderItemCrop}`
                        : option?.salesOrderItemCrop 
                        ? `Crop: ${option.salesOrderItemCrop}`
                        : null,
                      option?.purchaseOrderItemBuyingGrade
                        ? `Buying Grade: ${option.purchaseOrderItemBuyingGrade}`
                        : option?.salesOrderItemBuyingGrade
                        ? `Buying Grade: ${option.salesOrderItemBuyingGrade}`
                        : null,
                    ].filter((value) => value);

                    return values.join(" - ");
                  }}
                  value={shippingInstructions.filter((shippingInstruction) =>
                    filterTrade?.shippingInstructionIdList?.includes(
                      shippingInstruction.id,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterTrade({
                      ...filterTrade,
                      shippingInstructionIdList: newValue
                        .map((shippingInstruction) => shippingInstruction.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => {
                    if (option?.id === 'emptyShippingInstructions') {
    return (
      <li {...props} 
        style={{
          borderTop: '1px solid #eee',
          backgroundColor: '#f5f5f5'
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={filterTrade.isEmptyShippingInstruction.includes('true')}
              onChange={(e) => {
                e.stopPropagation();
               setFilterTrade({
          ...filterTrade,
              isEmptyShippingInstruction: e.target.checked 
                ? [...filterTrade.isEmptyShippingInstruction, 'true']
                : filterTrade.isEmptyShippingInstruction.filter(value => value !== 'true')
            });
              }}
            />
          }
          label="Empty Shipping Instructions"
        />
      </li>
    );
  }
                    const values = [
                       option?.id,
                         option?.finalShippingInstructionNumber
                        ? `SI Number: ${option.finalShippingInstructionNumber}`
                        : null,
                      option?.purchaseOrderNumber
                        ? `SAP PO Number: ${option.purchaseOrderNumber}`
                        : null,
                      option?.purchaseOrderItemOrigin
                        ? `Origin: ${option.purchaseOrderItemOrigin}`
                        : option?.salesOrderItemOrigin 
                        ? `Origin: ${option.salesOrderItemOrigin}`
                        : null,
                         option?.purchaseOrderItemCrop
                        ? `Crop: ${option.purchaseOrderItemCrop}`
                        : option?.salesOrderItemCrop 
                        ? `Crop: ${option.salesOrderItemCrop}`
                        : null,
                      option?.purchaseOrderItemBuyingGrade
                        ? `Buying Grade: ${option.purchaseOrderItemBuyingGrade}`
                        : option?.salesOrderItemBuyingGrade
                        ? `Buying Grade: ${option.salesOrderItemBuyingGrade}`
                        : null,
                    ].filter((value) => value);

                    const optionLabel = values.join(" - ");
                    
                    return (
                      <li
                        {...props}
                        style={{
                          ...props.style,
                          backgroundColor: selected ? "lightblue" : undefined,
                          fontWeight: selected ? 700 : 400,
                        }}
                      >
                        {optionLabel}
                      </li>
                    );
                  }}
                  renderInput={(params) => {
                    const label =
                      filterTrade?.shippingInstructionIdList?.length >
                        0
                        ? `Shipping Instructions Selected (${filterTrade?.shippingInstructionIdList?.length})`
                        : "Shipping Instruction";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.shippingInstruction.inputValue}
                        onChange={(e) => {
                          updateComponentState("shippingInstruction", {
                            inputValue: e.target.value,
                          });
                        }}
                        onMouseDown={() => retrieveShippingInstructions()}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("shippingInstruction", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />
                <Autocomplete
                  multiple
                  id="outlined-select-shipment-request"
                  disableClearable
                  open={componentsState.shipmentRequest.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("shipmentRequest", {
                      dropdownOpen: true,
                    })
                  }
                  inputValue={componentsState.shipmentRequest.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("shipmentRequest", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
options={[
    { id: 'emptyShipmentRequests' }, 
  ...shipmentRequests.filter((shipmentRequest) =>
    filterTrade?.shipmentRequestIdList?.includes(
      shipmentRequest.id,
    ),
  ),
  ...shipmentRequests.filter(
    (shipmentRequest) =>
      !filterTrade?.shipmentRequestIdList?.includes(
        shipmentRequest.id,
      ),
  ),// Add this special option
]}
                  getOptionLabel={(option) => {
                    const values = [
                      option?.id,
                      option?.purchaseOrderNumber
                        ? `SAP PO Number: ${option.purchaseOrderNumber}`
                        : null,
                      option?.purchaseOrderStakeholderName
                        ? `Supplier: ${option.purchaseOrderStakeholderName}`
                        : null,
                      option?.purchaseOrderItemOrigin
                        ? `Origin: ${option.purchaseOrderItemOrigin}`
                        : option?.salesOrderItemOrigin 
                        ? `Origin: ${option.salesOrderItemOrigin}`
                        : null,
                         option?.purchaseOrderItemCrop
                        ? `Crop: ${option.purchaseOrderItemCrop}`
                        : option?.salesOrderItemCrop 
                        ? `Crop: ${option.salesOrderItemCrop}`
                        : null,
                      option?.purchaseOrderItemBuyingGrade
                        ? `Buying Grade: ${option.purchaseOrderItemBuyingGrade}`
                        : option?.salesOrderItemBuyingGrade
                        ? `Buying Grade: ${option.salesOrderItemBuyingGrade}`
                        : null,
                    ].filter((value) => value);

                    return values.join(" - ");
                  }}
                  value={shipmentRequests.filter((shipmentRequest) =>
                    filterTrade?.shipmentRequestIdList?.includes(
                      shipmentRequest.id,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterTrade({
                      ...filterTrade,
                      shipmentRequestIdList: newValue
                        .map((shipmentRequest) => shipmentRequest.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => {
                    if (option?.id === 'emptyShipmentRequests') {
    return (
      <li {...props} 
        style={{
          borderTop: '1px solid #eee',
          backgroundColor: '#f5f5f5'
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={filterTrade.isEmptyShipmentRequest.includes('true')}
              onChange={(e) => {
                e.stopPropagation(); // Prevent dropdown from closing
               setFilterTrade({
          ...filterTrade,
              isEmptyShipmentRequest: e.target.checked 
                ? [...filterTrade.isEmptyShipmentRequest, 'true']
                : filterTrade.isEmptyShipmentRequest.filter(value => value !== 'true')
            });
              }}
            />
          }
          label="Empty Shipment Requests"
        />
      </li>
    );
  }
                    const values = [
                       option?.id,
                      option?.purchaseOrderNumber
                        ? `SAP PO Number: ${option.purchaseOrderNumber}`
                        : null,
                      option?.purchaseOrderStakeholderName
                        ? `Supplier: ${option.purchaseOrderStakeholderName}`
                        : null,
                      option?.purchaseOrderItemOrigin
                        ? `Origin: ${option.purchaseOrderItemOrigin}`
                        : option?.salesOrderItemOrigin 
                        ? `Origin: ${option.salesOrderItemOrigin}`
                        : null,
                         option?.purchaseOrderItemCrop
                        ? `Crop: ${option.purchaseOrderItemCrop}`
                        : option?.salesOrderItemCrop 
                        ? `Crop: ${option.salesOrderItemCrop}`
                        : null,
                      option?.purchaseOrderItemBuyingGrade
                        ? `Buying Grade: ${option.purchaseOrderItemBuyingGrade}`
                        : option?.salesOrderItemBuyingGrade
                        ? `Buying Grade: ${option.salesOrderItemBuyingGrade}`
                        : null,
                    ].filter((value) => value);

                    const optionLabel = values.join(" - ");
                    
                    return (
                      <li
                        {...props}
                        style={{
                          ...props.style,
                          backgroundColor: selected ? "lightblue" : undefined,
                          fontWeight: selected ? 700 : 400,
                        }}
                      >
                        {optionLabel}
                      </li>
                    );
                  }}
                  renderInput={(params) => {
                    const label =
                      filterTrade?.shipmentRequestIdList?.length >
                        0
                        ? `Shipment Requests Selected (${filterTrade?.shipmentRequestIdList?.length})`
                        : "Shipment Request";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.shipmentRequest.inputValue}
                        onChange={(e) => {
                          updateComponentState("shipmentRequest", {
                            inputValue: e.target.value,
                          });
                        }}
                        onMouseDown={() => retrieveShipmentRequests()}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("shipmentRequest", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />
                <Autocomplete
                  multiple
                  id="outlined-select-purchase-order"
                  disableClearable
                  open={componentsState.purchaseOrder.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("purchaseOrder", {
                      dropdownOpen: true,
                    })
                  }
                  inputValue={componentsState.purchaseOrder.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("purchaseOrder", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
options={[
    { id: 'emptyPurchaseOrders' }, 
  ...purchaseOrders.filter((purchaseOrder) =>
    filterTrade?.purchaseOrderIdList?.includes(
      purchaseOrder.id,
    ),
  ),
  ...purchaseOrders.filter(
    (purchaseOrder) =>
      !filterTrade?.purchaseOrderIdList?.includes(
        purchaseOrder.id,
      ),
  ),
]}
                  getOptionLabel={(option) => {
                    const values = [
                      option?.id,
                      option?.purchaseOrderNumber
                        ? `SAP PO Number: ${option.purchaseOrderNumber}`
                        : null,
                      option?.stakeholderName
                        ? `Supplier: ${option.stakeholderName}`
                        : null,
                      option?.offerItemOrigin
                        ? `Origin: ${option.offerItemOrigin}`
                        : option?.salesOrderItemOrigin 
                        ? `Origin: ${option.salesOrderItemOrigin}`
                        : null,
                         option?.offerItemCrop
                        ? `Crop: ${option.offerItemCrop}`
                        : option?.salesOrderItemCrop 
                        ? `Crop: ${option.salesOrderItemCrop}`
                        : null,
                      option?.offerItemBuyingGrade
                        ? `Buying Grade: ${option.offerItemBuyingGrade}`
                        : option?.salesOrderItemBuyingGrade
                        ? `Buying Grade: ${option.salesOrderItemBuyingGrade}`
                        : null,
                    ].filter((value) => value);

                    return values.join(" - ");
                  }}
                  value={purchaseOrders.filter((purchaseOrder) =>
                    filterTrade?.purchaseOrderIdList?.includes(
                      purchaseOrder.id,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterTrade({
                      ...filterTrade,
                      purchaseOrderIdList: newValue
                        .map((purchaseOrder) => purchaseOrder.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => {
                    if (option?.id === 'emptyPurchaseOrders') {
    return (
      <li {...props} 
        style={{
          borderTop: '1px solid #eee',
          backgroundColor: '#f5f5f5'
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={filterTrade.isEmptyPurchaseOrder.includes('true')}
              onChange={(e) => {
                e.stopPropagation(); // Prevent dropdown from closing
               setFilterTrade({
          ...filterTrade,
              isEmptyPurchaseOrder: e.target.checked 
                ? [...filterTrade.isEmptyPurchaseOrder, 'true']
                : filterTrade.isEmptyPurchaseOrder.filter(value => value !== 'true')
            });
              }}
            />
          }
          label="Empty Purchase Orders"
        />
      </li>
    );
  }
                    const values = [
                       option?.id,
                      option?.purchaseOrderNumber
                        ? `SAP PO Number: ${option.purchaseOrderNumber}`
                        : null,
                      option?.stakeholderName
                        ? `Supplier: ${option.stakeholderName}`
                        : null,
                      option?.offerItemOrigin
                        ? `Origin: ${option.offerItemOrigin}`
                        : option?.salesOrderItemOrigin 
                        ? `Origin: ${option.salesOrderItemOrigin}`
                        : null,
                         option?.offerItemCrop
                        ? `Crop: ${option.offerItemCrop}`
                        : option?.salesOrderItemCrop 
                        ? `Crop: ${option.salesOrderItemCrop}`
                        : null,
                      option?.offerItemBuyingGrade
                        ? `Buying Grade: ${option.offerItemBuyingGrade}`
                        : option?.salesOrderItemBuyingGrade
                        ? `Buying Grade: ${option.salesOrderItemBuyingGrade}`
                        : null,
                    ].filter((value) => value);

                    const optionLabel = values.join(" - ");
                    
                    return (
                      <li
                        {...props}
                        style={{
                          ...props.style,
                          backgroundColor: selected ? "lightblue" : undefined,
                          fontWeight: selected ? 700 : 400,
                        }}
                      >
                        {optionLabel}
                      </li>
                    );
                  }}
                  renderInput={(params) => {
                    const label =
                      filterTrade?.purchaseOrderIdList?.length >
                        0
                        ? `Purchase Orders Selected (${filterTrade?.purchaseOrderIdList?.length})`
                        : "Purchase Order";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.purchaseOrder.inputValue}
                        onChange={(e) => {
                          updateComponentState("purchaseOrder", {
                            inputValue: e.target.value,
                          });
                        }}
                        onMouseDown={() => retrieveOrders("VENDOR")}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("purchaseOrder", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <Autocomplete
                  multiple
                  id="outlined-select-purchase-order"
                  disableClearable
                  open={componentsState.salesOrder.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("salesOrder", {
                      dropdownOpen: true,
                    })
                  }
                  inputValue={componentsState.salesOrder.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("salesOrder", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
options={[
    { id: 'emptySalesOrders' }, 
  ...salesOrders.filter((salesOrder) =>
    filterTrade?.salesOrderIdList?.includes(
      salesOrder.id,
    ),
  ),
  ...salesOrders.filter(
    (salesOrder) =>
      !filterTrade?.salesOrderIdList?.includes(
        salesOrder.id,
      ),
  ),
]}
                  getOptionLabel={(option) => {
                    const values = [
                      option?.id,
                      option?.salesOrderNumber
                        ? `SAP SO Number: ${option.salesOrderNumber}`
                        : null,
                      option?.stakeholderName
                        ? `Supplier: ${option.stakeholderName}`
                        : null,
                      option?.offerItemOrigin
                        ? `Origin: ${option.offerItemOrigin}`
                        : option?.salesOrderItemOrigin 
                        ? `Origin: ${option.salesOrderItemOrigin}`
                        : null,
                         option?.offerItemCrop
                        ? `Crop: ${option.offerItemCrop}`
                        : option?.salesOrderItemCrop 
                        ? `Crop: ${option.salesOrderItemCrop}`
                        : null,
                      option?.offerItemBuyingGrade
                        ? `Buying Grade: ${option.offerItemBuyingGrade}`
                        : option?.salesOrderItemBuyingGrade
                        ? `Buying Grade: ${option.salesOrderItemBuyingGrade}`
                        : null,
                    ].filter((value) => value);

                    return values.join(" - ");
                  }}
                  value={salesOrders.filter((salesOrder) =>
                    filterTrade?.salesOrderIdList?.includes(
                      salesOrder.id,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterTrade({
                      ...filterTrade,
                      salesOrderIdList: newValue
                        .map((salesOrder) => salesOrder.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => {
                    if (option?.id === 'emptySalesOrders') {
    return (
      <li {...props} 
        style={{
          borderTop: '1px solid #eee',
          backgroundColor: '#f5f5f5'
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={filterTrade.isEmptySalesOrder.includes('true')}
              onChange={(e) => {
                e.stopPropagation(); // Prevent dropdown from closing
               setFilterTrade({
          ...filterTrade,
              isEmptySalesOrder: e.target.checked 
                ? [...filterTrade.isEmptySalesOrder, 'true']
                : filterTrade.isEmptySalesOrder.filter(value => value !== 'true')
            });
              }}
            />
          }
          label="Empty Sales Orders"
        />
      </li>
    );
  }
                    const values = [
                       option?.id,
                      option?.salesOrderNumber
                        ? `SAP SO Number: ${option.salesOrderNumber}`
                        : null,
                      option?.stakeholderName
                        ? `Supplier: ${option.stakeholderName}`
                        : null,
                      option?.offerItemOrigin
                        ? `Origin: ${option.offerItemOrigin}`
                        : option?.salesOrderItemOrigin 
                        ? `Origin: ${option.salesOrderItemOrigin}`
                        : null,
                         option?.offerItemCrop
                        ? `Crop: ${option.offerItemCrop}`
                        : option?.salesOrderItemCrop 
                        ? `Crop: ${option.salesOrderItemCrop}`
                        : null,
                      option?.offerItemBuyingGrade
                        ? `Buying Grade: ${option.offerItemBuyingGrade}`
                        : option?.salesOrderItemBuyingGrade
                        ? `Buying Grade: ${option.salesOrderItemBuyingGrade}`
                        : null,
                    ].filter((value) => value);

                    const optionLabel = values.join(" - ");
                    
                    return (
                      <li
                        {...props}
                        style={{
                          ...props.style,
                          backgroundColor: selected ? "lightblue" : undefined,
                          fontWeight: selected ? 700 : 400,
                        }}
                      >
                        {optionLabel}
                      </li>
                    );
                  }}
                  renderInput={(params) => {
                    const label =
                      filterTrade?.salesOrderIdList?.length >
                        0
                        ? `Sales Orders Selected (${filterTrade?.salesOrderIdList?.length})`
                        : "Sales Order";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.salesOrder.inputValue}
                        onChange={(e) => {
                          updateComponentState("salesOrder", {
                            inputValue: e.target.value,
                          });
                        }}
                        onMouseDown={() => retrieveOrders("CUSTOMER")}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("salesOrder", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <Autocomplete
                  multiple
                  id="outlined-select-item"
                  disableClearable
                  open={componentsState.item.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("item", { dropdownOpen: true })
                  }
                  inputValue={componentsState.item.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("item", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={items}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.buyingGrade || ""} - ${
                      option?.crop || ""
                    } - ${option?.origin || ""}`
                  }
                  value={items.filter((item) =>
                    filterTrade?.itemIdList?.includes(item.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterTrade({
                      ...filterTrade,
                      itemIdList: newValue.map((item) => item.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.buyingGrade || ""} - ${
                        option?.crop || ""
                      } - ${option?.origin || ""}`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterTrade?.itemIdList?.length > 0
                        ? `Items Selected (${filterTrade?.itemIdList?.length})`
                        : "Item";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.item.inputValue}
                        onChange={(e) =>
                          updateComponentState("item", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveItems}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("item", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />
                <TextField
                  label="PO Company"
                  type="search"
                  id="outlined-select-company"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterTrade.poCompanyList || [],
                    onChange: (e) => {
                      setFilterTrade({
                        ...filterTrade,
                        poCompanyList: e.target.value,
                      });
                    },
                  }}
                >
                  {companies.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  label="SO Company"
                  type="search"
                  id="outlined-select-company"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterTrade.soCompanyList || [],
                    onChange: (e) => {
                      setFilterTrade({
                        ...filterTrade,
                        soCompanyList: e.target.value,
                      });
                    },
                  }}
                >
                  {companies.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <Autocomplete
                  multiple
                  id="outlined-select-warehouse"
                  disableClearable
                  open={componentsState.warehouse.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("warehouse", { dropdownOpen: true })
                  }
                  inputValue={componentsState.warehouse.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("warehouse", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={warehouses}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.code || ""} - ${
                      option?.name || ""
                    }`
                  }
                  value={warehouses.filter((warehouse) =>
                    filterTrade?.warehouseList?.includes(warehouse.name),
                  )}
                  onChange={(event, newValue) => {
                    setFilterTrade({
                      ...filterTrade,
                      warehouseList: newValue.map(
                        (warehouse) => warehouse.name,
                      ),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.code || ""} - ${
                        option?.name || ""
                      }`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterTrade?.warehouseList?.length > 0
                        ? `Warehouses Selected (${filterTrade?.warehouseList?.length})`
                        : "Warehouse";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.warehouse.inputValue}
                        onChange={(e) =>
                          updateComponentState("warehouse", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveWarehouse}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("warehouse", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <Autocomplete
                  multiple
                  id="outlined-select-destination"
                  disableClearable
                  open={componentsState.destination.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("destination", { dropdownOpen: true })
                  }
                  inputValue={componentsState.destination.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("destination", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={destinations}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.code || ""} - ${
                      option?.name || ""
                    }`
                  }
                  value={destinations.filter((destination) =>
                    filterTrade?.destinationList?.includes(destination.name),
                  )}
                  onChange={(event, newValue) => {
                    setFilterTrade({
                      ...filterTrade,
                      destinationList: newValue.map(
                        (destination) => destination.name,
                      ),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.code || ""} - ${
                        option?.name || ""
                      }`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterTrade?.destinationList?.length > 0
                        ? `Destinations Selected (${filterTrade?.destinationList?.length})`
                        : "Destination";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.destination.inputValue}
                        onChange={(e) =>
                          updateComponentState("destination", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveWarehouse}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("destination", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                {/*<TextField
                  id="outlined-number"
                  label="PO Buisness Partner"
                  value={filterTrade?.destination || ""}
                  onChange={(e) =>
                    setFilterTrade({
                      ...filterTrade,
                      destination: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-number"
                  label="SO Business Partner"
                  value={filterTrade?.destination || ""}
                  onChange={(e) =>
                    setFilterTrade({
                      ...filterTrade,
                      destination: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-number"
                  label="Number Of Cartons"
                  value={filterTrade?.numberOfCases || ""}
                  type="number"
              onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterTrade({
                      ...filterTrade,
                      numberOfCases: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-number"
                  label="Net Weight Per Carton"
                  value={filterTrade?.netWeightPerCase || ""}
                  type="number"
              onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterTrade({
                      ...filterTrade,
                      netWeightPerCase: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-number"
                  value={filterTrade?.volume || ""}
                  label="Volume"
                  type="number"
              onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterTrade({
                      ...filterTrade,
                      volume: e.target.value,
                    })
                  }
                />
                <TextField
                  label="Volume Unit"
                  type="search"
                  id="outlined-select-volume-unit"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterTrade.volumeUnitList || [],
                    onChange: (e) => {
                      setFilterTrade({
                        ...filterTrade,
                        volumeUnitList: e.target.value,
                      });
                    },
                  }}
                >
                  {units.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  id="outlined-number"
                  label="First Price"
                  value={filterTrade?.firstOfferPrice || ""}
                  type="number"
              onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterTrade({
                      ...filterTrade,
                      firstOfferPrice: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-number"
                  label="Final Price"
                  value={filterTrade?.finalPrice || ""}
                  type="number"
              onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterTrade({
                      ...filterTrade,
                      finalPrice: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-number"
                  label="SAP PO Number"
                  value={filterTrade?.purchaseOrderNumber || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterTrade({
                      ...filterTrade,
                      purchaseOrderNumber: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-number"
                  label="SAP SO Number"
                  value={filterTrade?.salesOrderNumber || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterTrade({
                      ...filterTrade,
                      salesOrderNumber: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-number"
                  label="SI Id"
                  value={filterTrade?.shippingInstructionId || ""}
                  type="number"
              onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterTrade({
                      ...filterTrade,
                      shippingInstructionId: e.target.value,
                    })
                  }
                />
*/}
                <TextField
                  label="Record Status"
                  type="search"
                  id="outlined-select-record-status"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterTrade.recordStatusList || [],
                    onChange: (e) => {
                      setFilterTrade({
                        ...filterTrade,
                        recordStatusList: e.target.value,
                      });
                    },
                  }}
                >
                  {recordStatus.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                  <MyFilters
                    componentName="TradeView"
                    filterState={filterTrade}
                    onApply={(saved) => setFilterTrade(saved)}
                  />
              </Grid>
              <br></br>
              <Grid
                container
                spacing={2}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="contained"
                    fullWidth
                    onClick={() => {
                      retrieveFilteredRecordsApi(filterTrade)
                        .then((response) => {
                          setRows(response?.data);
                        })
                        .catch((error) => {
                          console.log(error?.response?.data);
                        });
                    }}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="outlined"
                    fullWidth
                    size="small"
                    onClick={() => {
                      setFilterTrade({
                        id: 0,
                        operationTypeList: [],
                        statusList: [],
                        orderTypeList: [],
                        offerIdList: [],
                        companyList: [],
                        approvalStatusList: [],
                        orderStatusList: [],
                        itemIdList: [],
                        stakeholderIdList: [],
                        operationDate: null,
                        statusDeadline: null,
                        invoiceDate: null,
                        billOfLadingDate: null,
                        shipmentDate: null,
                        customerList: [],
                        firstSampleId: "",
                        secondSampleId: "",
                        costId: "",
                        warehouse: "",
                        storage: "",
                        firstSampleDate: null,
                        secondSampleDate: null,
                        firstSampleStatusList: [],
                        secondSampleStatusList: [],
                        paymentTerm: "",
                        paymentTermList: [],
                        incotermList: [],
                        packagingList: [],
                        orderDate: null,
                        validityDate: null,
                        volumeUnitList: [],
                        remark: "",
                        documentStatusList: [],
                        tobaccoCode: "",
                        salesGrade: "",
                        buyingGrade: "",
                        customerGrade: "",
                        internalGrade: "",
                        crop: null,
                        nicotine: null,
                        sugar: null,
                        volume: null,
                        numberOfCases: null,
                        netWeightPerCase: null,
                        firstOfferPrice: null,
                        finalPrice: null,
                        totalAmount: null,
                        purchaseOrderNumber: null,
                        salesOrderNumber: null,
                        shippingInstructionId: null,
                        billOfLadingNumber: null,
                        quantityRemainingInNetCase: null,
                        quantityRemainingInNetKg: null,
                        originList: [],
                        typeList: [],
                        leafFormList: [],
                        colorList: [],
                        storageList: [],
                        warehouseIdList: [],
                        destinationList: [],
                        recordStatusList: ["ACTIVE"],
                        shippingInstructionIdList: [],
                        shipmentRequestIdList: [],
                        purchaseOrderIdList: [],
                        salesOrderIdList: [],
                        isEmptyShipmentRequest: [],
                        isEmptyShippingInstruction: [],
                        isEmptyPurchaseOrder: [],
                        isEmptySalesOrder: [],
                      });
                    }}
                  >
                    Clear Filters
                  </Button>
                </Grid>
                {/*<Grid item xs={3} sm="auto">
                  <Button
                    disableElevation
                    variant="outlined"
                    fullWidth
                    onClick={() => setAddView(true)}
                  >
                    Add
                  </Button>
                </Grid>
                <Grid item xs="auto">
                  <ExportExcel
                    excelData={createNewExportObject(selectedData)}
                    fileName={"TradeHistoryExport"}
                    buttonLabel="Export Table"
                  />
                </Grid>*/}
              </Grid>
              <br></br>
            </Box>
          )}

          <Box sx={{ width: "100%" }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <EnhancedTableToolbar
                numSelected={selected.length}
                showFilters={showFilters}
                setShowFilters={setShowFilters}
                selected={selected}
                selectedData={selectedData}
              />
              <TableContainer style={{ maxHeight: 700 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  striped="columns"
                  style={{ width: "max-content" }}
                  sx={{
                    minWidth: 750,
                    "& .MuiTableCell-root": {
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                    },
                    "& .MuiTableCell-head": {
                      backgroundColor: "#20315d",
                      color: "white",
                      borderRight: "1px solid rgba(49, 64, 128, 1)",
                    },
                  }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={rows.length}
                  />
                  <TableBody>
                    {visibleRows.map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          style={
                            isSelected(row.id)
                              ? { background: "#d7e7fc" }
                              : (row?.shippingInstructionRecordStatus && row?.shippingInstructionRecordStatus==="PASSIVE")
                              ? {
                                textDecoration: "line-through",
                                background: "#9e9d9d",
                              }
                              : (row?.shipmentRequestRecordStatus && row?.shipmentRequestRecordStatus==="PASSIVE")
                              ? {
                                textDecoration: "line-through",
                                background: "#9e9d9d",
                              }
                              :(row?.orderRecordStatus && row?.orderRecordStatus==="PASSIVE")
                              ? {
                                textDecoration: "line-through",
                                background: "#9e9d9d",
                              }
                              :index % 2
                              ? { background: "#f0f0f0" }
                              : { background: "white" }
                          }
                          hover
                          onClick={(event) => handleClick(event, row.id, row)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.id}
                          selected={isItemSelected}
                          sx={{ cursor: "pointer" }}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {row?.id}
                          </TableCell>
                          <TableCell align="center">
                          <OrderButton
                              row={row}
                              id={row?.shippingInstructionShipmentRequestPurchaseOrderId ||
                                row?.shipmentRequestPurchaseOrderId ||
                                ((row?.operationType === "PO" ||
                                  row?.operationType === "PO CANCELLATION") &&
                                  row?.orderId)}
                              setEditOrder={setEditVendorOrder}
                            />
                          </TableCell>
                          <TableCell align="center">
                          <OrderButton
                              row={row}
                              id={row?.shippingInstructionShipmentRequestSalesOrderId ||
                                row?.shipmentRequestSalesOrderId ||
                                ((row?.operationType === "SO" ||
                                  row?.operationType === "SO CANCELLATION") &&
                                  row?.orderId)}
                              setEditOrder={setEditCustomerOrder}
                            />
                          </TableCell>
                          <TableCell align="center">
                          <ShipmentRequestButton
                              row={row}
                              id={row?.shippingInstructionShipmentRequestId ||
                                row?.shipmentRequestId}
                              setEditShipmentRequest={setEditShipmentRequest}
                            />
                          </TableCell>
                          <TableCell align="center">
                           <ShippingInstructionButton
                              row={row}
                              id={[row?.shippingInstructionId]}
                              setEditShippingInstruction={setEditShippingInstruction}
                            />
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              position: "sticky",
                              left: 50,
                              background: "inherit",
                              zIndex: 1,
                            }}
                          >
                            {row?.operationType}
                          </TableCell>
                          <TableCell align="center">
                            {(row?.shippingInstructionRecordStatus && row.shippingInstructionRecordStatus.split('')[0]) ||
                              (row?.shipmentRequestRecordStatus && row.shipmentRequestRecordStatus.split('')[0]) ||
                              (row?.orderRecordStatus && row.orderRecordStatus.split('')[0])}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              position: "sticky",
                              left: 150,
                              background: "inherit",
                              zIndex: 1,
                            }}
                          >
                            {(row?.shippingInstructionId &&
                              `${
                                row?.shippingInstructionShipmentRequestType
                              } ${
                                row?.finalShippingInstructionNumber || ""
                              }`) ||
                              (row?.operationType === "PO" &&
                                row?.purchaseOrderNumber) ||
                              (row?.operationType === "SO" &&
                                row?.salesOrderNumber) ||
                              (row?.operationType === "SR" &&
                                row?.shipmentRequestType) ||
                              ""}
                          </TableCell>
                          <TableCell align="center">
                            {(row?.shippingInstructionDate
                              ? format(
                                  new Date(
                                    row?.shippingInstructionDate,
                                  ),
                                  "dd/MM/yyyy",
                                )
                              : "") ||
                              (row?.shipmentRequestDate
                                ? format(
                                    new Date(row?.shipmentRequestDate),
                                    "dd/MM/yyyy",
                                  )
                                : "") ||
                              (row?.orderDate
                                ? format(
                                    new Date(row?.orderDate),
                                    "dd/MM/yyyy",
                                  )
                                : "")}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionShipmentRequestPurchaseOrderCompany ||
                              row?.shipmentRequestPurchaseOrderCompany ||
                              ((row?.operationType === "PO" ||
                                row?.operationType === "PO CANCELLATION") &&
                                row?.orderCompany)}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionShipmentRequestSalesOrderCompany ||
                              row?.shipmentRequestSalesOrderCompany ||
                              ((row?.operationType === "SO" ||
                                row?.operationType === "SO CANCELLATION") &&
                                row?.orderCompany)}
                          </TableCell>
                                                    <TableCell align="center">
                            {row?.shippingInstructionShipmentRequestNumberOfCases ||
                              row?.shipmentRequestNumberOfCases ||
                              row?.orderNumberOfCases}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionShipmentRequestNetWeightPerCase ||
                              row?.shipmentRequestNetWeightPerCase ||
                              row?.orderNetWeightPerCase}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionShipmentRequestShipmentQuantity
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(
                                  row?.shippingInstructionShipmentRequestShipmentQuantity,
                                )} ${
                                  row?.shippingInstructionShipmentRequestShipmentQuantityUnit
                                }`
                              : "" || row?.shipmentRequestShipmentQuantity
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(
                                  row?.shipmentRequestShipmentQuantity,
                                )} ${
                                  row?.shipmentRequestShipmentQuantityUnit
                                }`
                              : "" || row?.orderVolume
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row?.orderVolume)} ${
                                  row?.orderVolumeUnit
                                }`
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                          <ItemButton
                              row={row}
                              id={row?.shippingInstructionShipmentRequestPurchaseOrderOfferItemId ||
                                row?.shippingInstructionShipmentRequestSalesOrderOfferItemId ||
                                row?.shipmentRequestPurchaseOrderOfferItemId ||
                                row?.shipmentRequestSalesOrderOfferItemId ||
                                row?.orderOfferItemId}
                              setEditItem={setEditItem}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionShipmentRequestPurchaseOrderOfferItemBuyingGrade ||
                              row?.shippingInstructionShipmentRequestSalesOrderOfferItemBuyingGrade ||
                              row?.shipmentRequestPurchaseOrderOfferItemBuyingGrade ||
                              row?.shipmentRequestSalesOrderOfferItemBuyingGrade ||
                              row?.orderOfferItemBuyingGrade ||
                              row?.orderOfferItemBuyingGrade}
                          </TableCell>
                          <TableCell align="center">
                            {
                              row?.shippingInstructionShipmentRequestSalesOrderOfferSalesGrade ||
                              row?.shipmentRequestSalesOrderOfferSalesGrade ||
                              row?.orderOfferSalesGrade ||
                              row?.orderOfferSalesGrade}
                          </TableCell>                         
                           <TableCell align="center">
                            {
                              row?.shippingInstructionShipmentRequestCustomerGradeMark ||
                              row?.shipmentRequestCustomerGradeMark}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionShipmentRequestPurchaseOrderOfferItemCrop ||
                              row?.shippingInstructionShipmentRequestSalesOrderOfferItemCrop ||
                              row?.shipmentRequestPurchaseOrderOfferItemCrop ||
                              row?.shipmentRequestSalesOrderOfferItemCrop ||
                              row?.orderOfferItemCrop ||
                              row?.orderOfferItemCrop}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionShipmentRequestPurchaseOrderOfferItemOrigin ||
                              row?.shippingInstructionShipmentRequestSalesOrderOfferItemOrigin ||
                              row?.shipmentRequestPurchaseOrderOfferItemOrigin ||
                              row?.shipmentRequestSalesOrderOfferItemOrigin ||
                              row?.orderOfferItemOrigin ||
                              row?.orderOfferItemOrigin}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionWarehouse ||
                              row?.shipmentRequestWarehouse}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionDestination ||
                              row?.shipmentRequestDestination}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionShipmentRequestPurchaseOrderOfferStakeholderName ||
                              row?.shipmentRequestPurchaseOrderOfferStakeholderName ||
                              (row?.operationType === "PO" &&
                                row?.orderOfferStakeholderName)}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionShipmentRequestSalesOrderOfferStakeholderName ||
                              row?.shipmentRequestSalesOrderOfferStakeholderName ||
                              (row?.operationType === "SO" &&
                                row?.orderOfferStakeholderName)}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionPointOfLoading ||
                              row?.shipmentRequestPortOfLoading ||
                              row?.orderPortOfLoading}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionPointOfUnloading ||
                              row?.shipmentRequestPortOfDischarge ||
                              row?.orderPortOfDischarge}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionActualTimeOfArrival
                              ? format(
                                  new Date(
                                    row?.shippingInstructionActualTimeOfArrival,
                                  ),
                                  "dd-MMM-yyyy",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.timestamp
                              ? format(
                                  new Date(row.timestamp),
                                  "dd/MM/yyyy HH:mm",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">{row?.creator}</TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: (dense ? 33 : 53) * emptyRows,
                        }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
            <Stack direction="row" spacing={1} alignItems={"center"}>
              <FormControlLabel
                control={
                  <Switch checked={dense} onChange={handleChangeDense} />
                }
                label="Dense padding"
              />
            </Stack>
          </Box>
        </>
      )}
    </div>
  );
}
